var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{staticClass:"main-layout"},[_c('AppMenu'),_c('el-container',{staticStyle:{"margin-left":"70px"}},[_c('el-header',{staticClass:"main-layout__header",attrs:{"height":"auto"}},[_c('app-header',{attrs:{"title":_vm.title}})],1),_c('el-main',{staticStyle:{"overflow":"visible"}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }